import { render, staticRenderFns } from "./keyValue.vue?vue&type=template&id=2453cbfb&scoped=true"
import script from "./keyValue.vue?vue&type=script&lang=js"
export * from "./keyValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2453cbfb",
  null
  
)

export default component.exports